export default "__VITE_ASSET__4bc5a693__"